import { render } from "./AirwallexBalance.vue?vue&type=template&id=3597722e"
import script from "./AirwallexBalance.vue?vue&type=script&lang=js"
export * from "./AirwallexBalance.vue?vue&type=script&lang=js"

import "./AirwallexBalance.vue?vue&type=style&index=0&id=3597722e&lang=scss"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__